import * as Yup from 'yup';

export interface INoteCreateForm {
  note: string;
}

export const initialValues: INoteCreateForm = {
  note: '',
};

export const validationSchema = Yup.object().shape({
  note: Yup.string().required('validation.required'),
});
